<template>

<app-wrapper v-if="is.loaded && is.fetched">

    <app-inner :padded="!window.is.mobile" class="search" :row="true">

        <com-filter v-if="!window.is.mobile" v-on:change="onFilterChange" />

        <div class="search-content" :class="{'is-loading': is.fetching}">

            <div class="search-head">
                <com-filter v-if="window.is.mobile" v-on:change="onFilterChange" />
            </div>
            <com-results :loading="is.fetching" :results="results" />
            <com-pagination :current="current" :pages="pages" v-on:change="onPageChange" />

        </div>

    </app-inner>

</app-wrapper>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comFilter from './vacancies/Filter'
import comResults from './vacancies/Results'
import comPagination from './vacancies/Pagination'

export default {

    mixins: [mixinPage],

    components: {
        'com-filter': comFilter,
        'com-results': comResults,
        'com-pagination': comPagination
    },

    data: function() {

        return {
            results: [],
            is: {
                fetching: true,
                fetched: false
            },
            current: 1,
            total: 0,
            pages: 1,
            filter: {
                type: [],
                text: ''
            }
        }

    },

    computed: {

        query: function() {

            return this.$route.query

        },

        loaded: function() {

            return this.is.loaded

        }

    },

    watch: {

        query: {

            deep: true,

            handler: function() {

                this.fetch()

            }

        },

        loaded: function() {

            this.fetch()

        }

    },

    created: function() {

        this.current = (this.$route.query.page) ? this.$route.query.page : 1
        this.filter.text = (this.$route.query.text) ? this.$route.query.text : ''
        this.filter.type = (this.$route.query.type) ? this.$route.query.type.split(',') : []

    },

    methods: {

        onSortChange: function(value) {

            this.sort = value

            this.updateRoute()

        },

        onPageChange: function(value) {

            this.current = value

            this.updateRoute(true)

        },

        onFilterChange: function(value) {

            this.filter = value

            this.updateRoute()

        },

        updateRoute: function(pageChange) {

			pageChange = pageChange || false

            var query = {}

            if (this.filter.text) query.text = this.filter.text
            if (this.filter.type.length) query.services = this.filter.type.join(',')
			if (this.current > 1 && pageChange) query.page = this.current

            this.$router[(pageChange) ? 'push' : 'replace']({
                name: 'Vacancies',
                query: query
            }).catch(function() {

            })

        },

        fetch: function() {

            this.is.fetching = true

            this.$api.request('vacancies', {
                filter: this.filter,
                page: this.current
            }).then(function(json) {

				this.results = json.results
				this.sort = json.sort
                this.total = json.total 
                this.pages = json.pages 
				this.current = json.page
				
				if (this.current !== 1) window.scrollTo(0, 0)

                this.is.fetching = false
                this.is.fetched = true

            }.bind(this), function() {

                this.is.fetching = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.is-tablet .search {
    padding-left: 20px!important;
    padding-right: 20px!important;
}

.search-content {
    flex-grow: 1;
    flex-basis: 0;
    transition: opacity 100ms linear;
}

.search-content.is-loading {
    background-image: url(~@/assets/app.load.gif);
    background-position: 50% 240px;
    background-repeat: no-repeat;
}

.search-content.is-loading > * {
    opacity: 0.75;
}

.is-mobile .search-head {
    display: flex;
    margin-top: 10px;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
}

</style>
